<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>

            <vue-headful :title="`Publish: ${form.form_name}  :: MeritEHS`"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/inspections/forms`">
                            <i class="fa fa-clipboard"></i> Inspection Forms
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/inspections/forms/view/${form.inspection_form_id}`">
                            {{ form.form_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">Publish</li>
                </ol>
            </h4>

            <div class="card">
                <div class="card-body">
                    <template v-if="form.published_at">
                        <div class="alert alert-warning">
                            This Form has already been published.
                        </div>
                    </template>
                    <template v-else>
                        <div class="alert alert-success">
                            You are about to publish this form. Once published, you cannot edit sections and elements. The form will be locked. You can only add new sections and new elements.
                        </div>
                        <button class="btn btn-sm btn-success" v-on:click="publishForm()" :disabled="saving">
                            <span v-if="saving">Publishing...</span>
                            <span v-else>Publish</span>
                            Form
                        </button>
                    </template>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            loading: true,
            saving: false,
            inspection_form_id: this.$route.params.id,
            form: {},
        }
    },

    methods: {
        getForm() {
            //Get the data
            this.$http
                .get('inspections/forms/publish/' + this.inspection_form_id)
                .then(response => {
                    //Set all the data
                    this.form = response.data;

                    //Set loading
                    this.loading = false;
                })
                .catch(response => {

                });
        },

        publishForm(){
            //Helper
            this.saving = true;

            //Send the data
            this.$http
                .post('inspections/forms/publish/' + this.inspection_form_id)
                .then(response => {
                    //Alert
                    this.$toastr.success('Form Published');

                    //Send back
                    this.$router.push('/inspections/forms/view/' + this.inspection_form_id);
                })
                .catch(err => {
                    //Alert
                    this.$toastr.error(err.response.data);
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
        },
    },

    mounted() {
        //Get the inspections
        this.getForm();
    }
}
</script>
